import React from "react";
import styled from "styled-components";
import { CardElement } from "@stripe/react-stripe-js";

import StripePowered from "assets/images/stripe.svg?react";

const Wrapper = styled.div`
  display: inline-block;
`;

const CardContainer = styled(CardElement)`
  width: 100%;
  height: 3.125rem;
  padding: 1rem 0.3125rem;
  border: ${props => props.theme.accountCardElementCardContainerBR};
  background: ${props => props.theme.accountCardElementCardContainerBG};
  box-sizing: border-box;
  margin-bottom: 0.3125rem;
`;

const StripeBlk = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StripeLink = styled.a`
  text-decoration: none;
`;

const StripePoweredIcon = styled(StripePowered)`
  width: auto;
  height: 0.8125rem;
`;

const AccountCardElement = ({ className = "", options, onChange = () => null }) => (
  <Wrapper className={className} data-private>
    <CardContainer options={options} onChange={onChange} />
    <StripeBlk>
      <StripeLink href="https://stripe.com/" target="_blank" rel="noopener noreferrer">
        <StripePoweredIcon />
      </StripeLink>
    </StripeBlk>
  </Wrapper>
);

export { CardElement };

export default AccountCardElement;
